import { useCallback, useEffect, useState } from "react";
import LoadMorePagination from "../../../../Components/LoadeMore";
import Styles from "./Unified_Ledger.module.css";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../commons/Accordion";
import { formatDate, formatSlotTime } from "../../../../helpers/dateFormat";
import ConnectionModal from "../../../../Components/Modals/ConGen/Connection/ConnectionModal";
import { openBilateralChat } from "../../../../Components/Modals/Banking/CreateEdit/helpers";
import {
  fetchMainScreenActiveConnection,
  setActiveListingId,
} from "../../../../Redux/Slices/CapacitySlice";
import {
  LeftSideBtns,
  RightSideBtn,
} from "../../../../Components/ConsumerGenerator/ListingContainer/AvailableListing/AvailableListing";
import { getCBLedgerOngoing } from "../../../../Services/ApiCalling/unifiedLedger";

const SummaryInnerHeader = () => (
  <div
    style={{ marginBottom: "10px" }}
    className={Styles.accordionSummaryContainer}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "30%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "9%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th
            style={{ paddingLeft: "35px" }}
            className={Styles.summaryInnerHeaderCell}
          >
            Counterparty
          </th>
          <th className={Styles.summaryInnerHeaderCell}>Quantity</th>
          <th className={Styles.summaryInnerHeaderCell}>Energy Rate</th>
          <th className={Styles.summaryInnerHeaderCell}>Date Range</th>
          <th className={Styles.summaryInnerHeaderCell}>Time Range</th>
        </tr>
      </thead>
    </table>
  </div>
);

const getRateLabel = (conn) => {
  if (!conn) return "";
  if (conn?.energyRateType === "FIXED") return `${conn?.amount}`;
  return `${conn?.energyRateType === "DAM_PLUS" ? "DAM+" : "DAM-"}${
    conn?.amount
  }`;
};

const BilateralConnections = ({
  matches,
  parentName,
  dispatch,
  showStatusButtons = true,
  showHeader = false,
}) => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const myDataKey =
    role === "consumer" ? "capacityConsumer" : "capacityGenerator";
  if (!Array.isArray(matches) || matches.length === 0) return null;

  return (
    <>
      {showHeader && <SummaryInnerHeader />}
      {matches.map((m, idx) => {
        if (!Object.keys(m || {}).includes("bilateralConnections")) return null;
        const key = m?.id ?? m?.name ?? idx;
        return (
          <div
            style={{
              margin: "7px",
              border: "var(--border-level2)",
              borderRadius: "10px",
            }}
            key={key}
          >
            <div
              style={{ paddingRight: "15px" }}
              className={`display_flex_row ${Styles.accHeaderTable_name}`}
            >
              <div
                style={{ marginLeft: "0.7%" }}
                className={`table_text_align_left ${Styles.nameCompanyDetails}`}
              >
                <div>
                  {m?.[userDataKey]?.consumerName ||
                    m?.[userDataKey]?.generatorName}
                </div>
                <div>{m?.[userDataKey]?.name}</div>
              </div>
            </div>

            {Array.isArray(m?.bilateralConnections) &&
              m.bilateralConnections
                .filter((conn) => conn.status !== "REJECTED")
                .map((conn, i) => (
                  <table
                    className={Styles.ledgerTableHeading}
                    key={conn?.id ?? i}
                    style={{
                      width: "100%",
                      tableLayout: "fixed",
                      color: "var(--fourth-color-text)",
                      fontSize: "12px",
                    }}
                  >
                    <colgroup>
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "30%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "9%" }} />
                    </colgroup>
                    <tbody
                      style={{
                        textAlign: "center",
                        textWrap: "nowrap",
                      }}
                    >
                      <tr style={{ height: "40px" }}>
                        <td
                          style={{
                            textAlign: "left",
                            paddingLeft: "30px",
                            color: "#8C8A96",
                          }}
                        >
                          Connection {i + 1}
                        </td>
                        <td>{conn?.quantity} (MW)</td>
                        <td>{getRateLabel(conn)} (₹/kWh)</td>
                        <td>
                          {formatDate(conn?.dateStartAt)} -{" "}
                          {formatDate(conn?.dateEndAt)}
                        </td>
                        <td>
                          {formatSlotTime(conn?.slotStartAt)} -{" "}
                          {formatSlotTime(conn?.slotEndAt)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ))}

            {showStatusButtons && (
              <div
                style={{ paddingRight: "calc(100vw - 98vw)" }}
                className={Styles.statusBtnContainer}
              >
                <LeftSideBtns showEditDocs={true} clickedIndex={idx} />

                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <button
                    type="button"
                    className={Styles.chatButton}
                    onClick={() => {
                      let chatId;
                      if (role === "consumer") {
                        chatId = `${m[myDataKey]?.name?.split("_")?.[0]}_${m[userDataKey]?.name?.split("_")?.[0]}`;
                      } else {
                        chatId = `${m[userDataKey]?.name?.split("_")?.[0]}_${m[myDataKey]?.name?.split("_")?.[0]}`;
                      }

                      openBilateralChat(dispatch, {
                        header: m?.[userDataKey]?.name,
                        fromUser: m?.[myDataKey]?.name,
                        toUser: m?.[userDataKey]?.name,
                        chatId,
                        type: "BILATERAL",
                        hidechat: false,
                      });
                    }}
                  >
                    Chat
                  </button>

                  <RightSideBtn clickedIndex={idx} />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

const SummaryHeader = () => (
  <div
    style={{ position: "sticky", top: "0px", zIndex: 99 }}
    className={Styles.accordionSummaryContainer}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "17%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>E:Tender No.</th>
          <th className={Styles.summaryHeaderCell}>E:RA No.</th>
          <th className={Styles.summaryHeaderCell}>Tender Duration</th>
          <th className={Styles.summaryHeaderCell}>Bidding Duration</th>
          <th className={Styles.summaryHeaderCell}>EMD</th>
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryRow = ({
  ele,
  index,
  expanded,
  onToggle,
  userDataKey,
  role,
  openRequisitionModal,
  setOpenRequisitionModal,
  openRequisitionModalData,
  setOpenViewInjectionModalData,
  setOpenRequisitionModalData,
  setOpenViewInjectionModal,
  openViewInjectionModal,
  activeTab,
}) => {
  const [openConnectionHistory, setOpenConnectionHistory] = useState(false);
  const dispatch = useDispatch();
  const mainScreenActiveConnectionLoading = useSelector(
    (state) => state?.CapacitySlice?.fetchMainScreenActiveConnectionLoading,
  );
  const fetchLedgerBidsLoading = useSelector(
    (state) => state?.CapacitySlice?.fetchLedgerBidsLoading,
  );

  const mainScreenActiveConnectionData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection,
  );

  const showLoader =
    mainScreenActiveConnectionLoading || fetchLedgerBidsLoading;

  if (!ele) return null;

  return (
    <>
      <ConnectionModal
        open={openConnectionHistory}
        onClose={() => setOpenConnectionHistory(false)}
        connectionId={ele?.id}
      />{" "}
      <div
        className={expanded === index ? "" : Styles.detailsMainDrop_inactive}
      >
        <Accordion
          style={{
            backgroundColor: "#f3f5f8",
            marginTop: index === 0 ? "0px" : "3px",
            border:
              expanded === index
                ? "1px solid var(--primary-color-text)"
                : "none",
            borderRadius: "10px",
          }}
          expanded={expanded === index}
          onChange={() => onToggle(index)}
        >
          <AccordionSummary
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              borderBottom: expanded === index ? "1px solid #DFEAF2" : "none",
              borderBottomLeftRadius: expanded === index ? "0px" : "8px",
              borderBottomRightRadius: expanded === index ? "0px" : "8px",
            }}
          >
            <div className={Styles.accordionSummaryContainer}>
              <table
                className={Styles.summaryTable}
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "17%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "12%" }} />
                </colgroup>
                <tbody>
                  <tr style={{ fontWeight: "500" }}>
                    <td className={Styles.summaryCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <ExpandMoreIcon
                          style={{ fontSize: "18px" }}
                          className={`${Styles.expandIconLeft} ${
                            expanded === index ? Styles.rotateIcon : ""
                          }`}
                        />
                        {index + 1}
                      </div>
                    </td>
                    <td
                      title={ele?.[userDataKey]?.name}
                      className={Styles.summaryCell}
                    >
                      {ele?.tenderNumber}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.auctionNumber || "-"}
                    </td>
                    <td className={Styles.summaryCell}>
                      {formatDate(ele?.tenderStartDateTime) +
                        " - " +
                        formatDate(ele?.tenderCloseDateTime)}
                    </td>
                    <td className={Styles.summaryCell}>
                      {formatDate(ele?.bidStartDateTime) +
                        " - " +
                        formatDate(ele?.bidCloseDateTime)}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.emdPerMw + " (₹/MW)"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionSummary>

          <AccordionDetails
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            {/* details wrapper: show loader inside this container */}
            <div
              style={{
                padding: "10px",
                border: "none",
              }}
              className={Styles.accordionDetailsContainerUploadDocs}
            >
              {showLoader && (
                <div className={Styles.loaderContainer}>
                  <div
                    className={Styles.loader}
                    role="status"
                    aria-label="loading connection"
                  />
                </div>
              )}

              {!showLoader &&
                (Array.isArray(mainScreenActiveConnectionData) &&
                mainScreenActiveConnectionData.length ? (
                  <>
                    <BilateralConnections
                      myListingName={ele?.name}
                      activeParentTab={activeTab}
                      matches={mainScreenActiveConnectionData}
                      userDataKey={userDataKey}
                      parentName={ele?.name}
                      dispatch={dispatch}
                      openViewInjectionModal={openViewInjectionModal}
                      setOpenViewInjectionModal={setOpenViewInjectionModal}
                      setOpenViewInjectionModalData={
                        setOpenViewInjectionModalData
                      }
                      showHeader={mainScreenActiveConnectionData.length > 0}
                    />
                  </>
                ) : (
                  <div className={Styles.noDataContainer}>
                    No matching records
                  </div>
                ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

const RA = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [ledgerData, setLedgerData] = useState();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const myDataKey =
    role === "consumer" ? "capacityConsumer" : "capacityGenerator";
  const [expanded, setExpanded] = useState(0);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [openRequisitionModal, setOpenRequisitionModal] = useState(false);
  const [openRequisitionModalData, setOpenRequisitionModalData] =
    useState(null);
  const [openViewInjectionModal, setOpenViewInjectionModal] = useState(false);

  useEffect(() => {
    async function getLedgerData() {
      try {
        setLoading(true);
        const res = await getCBLedgerOngoing({
          currentPage: page,
          size: 10,
          tenderType: "RA",
        });
        if (res?.data?.code === 200) {
          const newData = res.data.data.page || [];
          setLedgerData((prevData) =>
            page === 0 ? newData : [...prevData, ...newData],
          );
          const { totalPages, currentPage } = res.data.data;
          setHasMore(currentPage < totalPages - 1);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching RA ledger ongoing data:", error);
        setLoading(false);
      }
    }
    getLedgerData();
  }, [page]);

  useEffect(() => {
    setExpanded(0);
  }, []);

  useEffect(() => {
    if (ledgerData && ledgerData.length) {
      let capacityId =
        role === "consumer"
          ? ledgerData[expanded]?.capacityId
          : ledgerData[expanded]?.generatorCapacityId;
      dispatch(setActiveListingId(capacityId));
    }
  }, [dispatch, expanded, ledgerData, myDataKey, role]);

  const handleAccordionChange = useCallback(
    (val) => {
      setExpanded((prev) => (prev === val ? -1 : Number(val)));
    },
    [setExpanded],
  );

  const handleLoadMore = () => setPage((prev) => prev + 1);

  useEffect(() => {
    if (!Array.isArray(ledgerData) || expanded === -1) return;
    let capacityId =
      role === "consumer"
        ? ledgerData[expanded]?.capacityId
        : ledgerData[expanded]?.generatorCapacityId;

    const capId = capacityId;
    if (!capId) return;

    dispatch(fetchMainScreenActiveConnection({ capId }));
  }, [ledgerData, dispatch, expanded, myDataKey, role]);

  return (
    <>
      {!loading && (!ledgerData || ledgerData.length === 0) && (
        <div className={Styles.noDataScreen}>
          <div className={Styles.noDataIcon} />
          <div className={Styles.noDataTitle}>No Data Available</div>
          <div className={Styles.noDataSubtitle}>
            There is currently no data to display.
          </div>
        </div>
      )}
      {ledgerData?.length > 0 && <SummaryHeader />}
      <LoadMorePagination
        hasMore={hasMore}
        onLoadMore={handleLoadMore}
        loading={loading}
      >
        {ledgerData?.map((ele, index) => (
          <SummaryRow
            setOpenRequisitionModal={setOpenRequisitionModal}
            setOpenRequisitionModalData={setOpenRequisitionModalData}
            openRequisitionModal={openRequisitionModal}
            openRequisitionModalData={openRequisitionModalData}
            openViewInjectionModal={openViewInjectionModal}
            setOpenViewInjectionModal={setOpenViewInjectionModal}
            key={ele?.id}
            ele={ele}
            index={index}
            expanded={expanded}
            onToggle={handleAccordionChange}
            userDataKey={userDataKey}
            role={role}
          />
        ))}
      </LoadMorePagination>
    </>
  );
};

export default RA;
